import React from "react";
import { Phone, Mail } from "lucide-react";
import { useI18n } from "../i18n";

const SUPPORT_PHONE = "514.536.3097";
const SUPPORT_EMAIL = "cs@2tsticker.ca";

export default function TopBar() {
  const { t } = useI18n();
  return (
    <div className="bg-nbblack text-white" data-testid="top-bar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-9 flex items-center justify-end gap-4 sm:gap-6">
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          data-testid="support-email-top"
          className="inline-flex items-center gap-1.5 font-head font-bold text-xs sm:text-sm hover:text-nbyellow transition-colors"
        >
          <Mail size={14} className="shrink-0" />
          <span className="hidden sm:inline">{SUPPORT_EMAIL}</span>
          <span className="sm:hidden">{t("common.support")}</span>
        </a>
        <a
          href={`tel:+1${SUPPORT_PHONE.replace(/\D/g, "")}`}
          data-testid="support-phone-top"
          className="inline-flex items-center gap-1.5 font-head font-bold text-xs sm:text-sm hover:text-nbyellow transition-colors"
        >
          <Phone size={14} className="shrink-0" />
          {SUPPORT_PHONE}
        </a>
      </div>
    </div>
  );
}
